import blackLogo from "../images/R1Jackal2.png"
import whiteLogo from "../images/R1JackalWhite3.png"
import React from 'react';
import { Outlet, Link } from "react-router-dom";
import '../styles/Header.css';

function Header() {
  return (
    <div>
      <nav class="navbar navbar-dark bg-dark" id="header">
        <div class="container d-flex text-center justify-content-center align-items-center" id="headerDiv">
          {
            (window.location.pathname.includes("emailGenerator")) ?
              (<a href={"./emailGenerator" + window.location.search} class="ms-5 headerLetters">
                <img src={blackLogo} class="ms-5 align-middle my-2 headerLogo" width="120" height="120" alt=""></img>
                {/* <h1 class="ps-5 ms-5 py-2 text-center justify-content-center align-items-center navbar-brand text-dark display-5 fw-bold ">Email Generator</h1> */}
              </a>) :
              (<a href="/" class="headerLetters">
                <img src={blackLogo} class="align-middle my-4 headerLogo" width="140" height="140" alt=""></img>
                <h1 class="ps-5 py-2 align-items-center headerLetters navbar-brand text-dark">Jackal</h1>
              </a>)
          }
        </div>
        <div class="container d-flex text-center justify-content-center align-items-center">
        </div>
      </nav>
      <div class="main-content">
        <Outlet />
      </div>
      {
        (window.location.pathname.includes("emailGenerator")) ?
          (<></>) :
          (<footer class="d-flex flex-wrap justify-content-between align-items-center bg-dark" id="footer">
            <p class="col-md-4 mb-0 text-light fw-bold ps-5">v2.3.2</p>
            <a href="/" class="col-md-4 d-flex align-items-center justify-content-center me-md-auto">
              <img src={whiteLogo} class="align-middle mt-2 mb-2 headerLogo" width="50" height="50" alt=""></img>
            </a>
          </footer>)
      }
    </div>
  );
}
export default Header